/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import {
    Box,
    Stack,
    IconButton,
    Tooltip,
    Divider,
    Autocomplete,
    TextField,
    FormHelperText,

} from '@mui/material';
// eslint-disable-next-line import/no-unresolved
import { IoMdRefresh } from "react-icons/io";
import { useLocation } from 'react-router';
import { Icon as Iconify } from '@iconify/react';
import ApprovalHierarchyMasterServices from './ApprovalHierarchyMasterServices';

import LoadingProgressBar from '../../../components/loading-screen/LoadingScreen';
import ModalPopUp from '../../../commons/ModalPopup';
import PopUpHandle from '../../../commons/PopUpHandle';
import { useAppStore } from '../../../store/appStore';




export default function ApprovalHierarchyFilter({ open, onClose, onFilterChange, searchControls = [], getRequiredData, pageName }) {
    const location = useLocation();
    const { handleSubmit, reset, resetField, control, setValue, watch } = useForm();
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState(null);

    const [opene, setOpene] = useState(false);
    const [error, setError] = useState('');
    const [errorCode, setErrorCode] = useState(0);
    const [alert, setAlert] = useState({ severity: '', message: '', show: false });
    const handleClose = () => {
        setOpene(false);
    };


    const [isReset, setIsReset] = useState(0);
    const values = watch();
    // State to hold the selected values for each Autocomplete component
    
    
    const {
        setFilterControlValues, filterControlValues, setHoverFilterValues,
        setFilterPayload
    } = useAppStore();

    
        
       
         
            
       

    

    const getFilterValues = JSON.parse(sessionStorage.getItem('filterValues'));
    useEffect(() => {
        // Reset requiredData when pageName changes
        getRequiredData([], []);
    }, [pageName, getRequiredData]);




    function removeSelectAllKeyValue(controls, payload) {
        const controlMap = new Map(
            controls.map(ctrl => [ctrl.ValueExpr, ctrl])
        );

        function extractValueExpr(controlId) {
            if (controlId.includes('-')) {
                const parts = controlId.split('-');
                return parts[parts.length - 1];
            }
            return controlId;
        }

        return payload.filter(entry => {
            const valueExpr = extractValueExpr(entry.ControlId);
            const ctrl = controlMap.get(valueExpr);
            if (!ctrl) return true;

            if (ctrl.DataType.toLowerCase() === "multiselectdropdown") {
                const defaultValues = ctrl.DefaultValues || [];
                if (entry.Values.length === defaultValues.length) {
                    return false;
                }
            }
            return true;
        });
    }


    const onSubmit = async (data) => { // NOSONAR
        setFilterControlValues(data);
        try {
            setLoading(true); // Show loading state

            const formData = Object.keys(data)
                .filter(key => {
                    const value = data[key];
                    return (
                        value !== null &&
                        value !== undefined &&
                        value !== 'null' &&
                        (Array.isArray(value) ? value.length > 0 : value !== '')
                    );
                })
                .map(key => ({
                    ControlId: key,
                    Values: Array.isArray(data[key])
                        ? data[key].map(val => Number(val))
                        : [Number(data[key])]
                }));

            setHoverFilterValues(getFilterValues);
            getRequiredData(getFilterValues);
            // If formData has valid entries
            if (formData.length > 0) {
                // Call the search data service

                const finalPayload = removeSelectAllKeyValue(searchControls, formData);
                setFilterPayload(finalPayload);
                const response = await ApprovalHierarchyMasterServices.SearchApprovalHierarchy(finalPayload);                
                onClose(); // Close the form
                // Handle response
                if (response === null || response.error) {
                    setError(response?.error?.message || 'Error occurred');
                    setErrorCode(response?.error?.code || 0);
                    setOpene(true);
                } else {
                     //  console.log("Success");
                    setAlert({ severity: 'success', message: response.Message || 'Filtered Successfully.', show: true });
                    setTimeout(() => setAlert({ ...alert, show: false }), 1500);
                }

                // Check if the response contains an error with code 404
                if (response?.error?.code === 404) {
                    onFilterChange(['error']); // Pass 'error' to the onFilterChange handler
                } else {
                    onFilterChange(response); // Pass the response to the onFilterChange handler
                }
            } else {
                setFilterPayload(null);
                setHoverFilterValues([])
                const response = await ApprovalHierarchyMasterServices.SearchApprovalHierarchy([]);                
                onClose(); // Close the form

                // Handle response
                if (response === null || response.error) {
                    setError(response?.error?.message || 'Error occurred');
                    setErrorCode(response?.error?.code || 0);
                    setOpene(true);
                } else {
                     //  console.log("Success");
                    setAlert({ severity: 'success', message: response.Message || 'Filtered Successfully.', show: true });
                    setTimeout(() => setAlert({ ...alert, show: false }), 1500);
                }

                // Check if the response contains an error with code 404
                if (response?.error?.code === 404) {
                    onFilterChange(['error']); // Pass 'error' to the onFilterChange handler
                } else {
                    onFilterChange(response); // Pass the response to the onFilterChange handler
                }
            }
        } catch (err) {
            setErrorCode(err?.response?.data?.error?.code);
            setError(err?.response?.data?.error?.message);
            setOpene(true);
           


            if (err?.response?.status === 404) {
                onFilterChange(['error']);
            }
            // ; // Ensure the 'error' array is passed on error
        } finally {
            sessionStorage.setItem('filteredUrl', JSON.stringify({ currentUrl: location.pathname }));
            setLoading(false); // Hide loading state
            setFilteredData(data); // Update the filtered data state
            /// reset(); // Reset the form
        }
    };




    const setFieldValues = (data) => {
        if (data !== null) {
            Object.entries(data).forEach(([key, value]) => {
                setValue(key, value);
            });
        }
    };
    
    useEffect(() => {
        if (open !== false) {
            setFieldValues(filterControlValues);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const defaultValues = {};
    searchControls.forEach(item => {
        defaultValues[`${item.TableName}-${item.ValueExpr}`] = null;
    });


    const handleReset = () => {


        // Clear session storage
        sessionStorage.removeItem('filterValues');
        sessionStorage.removeItem('filteredUrl');

        // Clear local state
        setFilteredData(null);
        setIsReset(prev => prev + 1);

        Object.entries(values).forEach(([key, value]) => {
            setValue(key, null);
            resetField(key);
            document.forms[0]?.reset();
        });

        reset(defaultValues);        
        setFilterControlValues([]);

     //   setHoverFilterValues(null);
    };






    return (
        
        <ModalPopUp open={open} onClose={onClose} title='Filter' >
            {
                searchControls &&

                <form onSubmit={handleSubmit(onSubmit)} style={{ minHeight: 0, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    <Stack spacing={2} sx={{ pb: 1.3, pt: 0.1, display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 0 }}>
                        <Box
                            sx={{
                                overflow: "hidden",
                                rowGap: 2,
                                columnGap: 2,
                                display: 'grid',
                                // gridTemplateColumns='repeat(4, 1fr)'
                                gridTemplateColumns: {
                                    xs: '1fr',
                                    sm: '1fr',
                                    md: '1fr 1fr',
                                    lg: '1fr 1fr ',
                                    xl: '1fr 1fr 1fr'
                                },
                                gridAutoRows: 'min-content',
                                paddingTop: '0.4rem',
                                // border: '2px solid red',
                            }}
                            >
                                {searchControls.map((field) => ( // NOSONAR
                                    <Controller
                                        key={field.LabelName}
                                        name={`${field.TableName}-${field.ValueExpr}`}
                                        control={control}
                                        defaultValue={defaultValues[field.LabelName] || ''} // Ensure default value is handled properly
                                        render={({ field: controllerField, fieldState }) => {
                                            switch (field.DataType) { // NOSONAR
                                                case 'Dropdown':
                                                    return (
                                                        <div>

                                                            <Autocomplete
                                                                options={Array.isArray(field.DefaultValues) ? field.DefaultValues : []}
                                                                size="small"
                                                                getOptionLabel={(option) => option[field.DisplayExpr] || ''}
                                                                multiple={field.multiple || false}
                                                                renderOption={(props, option) => <li {...props} key={option[field?.ValueExpr]}>{option[field?.DisplayExpr]}</li>}
                                                                value={
                                                                    Array.isArray(controllerField.value)
                                                                        ? controllerField.value.map((val) =>
                                                                            (field.DefaultValues || []).find(
                                                                                (opt) => opt[field.ValueExpr] === val
                                                                            )
                                                                        )
                                                                        : (field.DefaultValues || []).find(
                                                                            (opt) => opt[field.ValueExpr] === controllerField.value
                                                                        ) || null
                                                                }
                                                                onChange={(event, newValue, reason) => {
                                                                    if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                                    if (Array.isArray(newValue)) {
                                                                        const newValues = newValue.map((val) => val[field.ValueExpr]);
                                                                        controllerField.onChange(newValues);
                                                                    } else {
                                                                        const value = newValue ? newValue[field.ValueExpr] : '';
                                                                        controllerField.onChange(value);
                                                                    }

                                                                    // Update session storage for display values
                                                                    const filterValues = JSON.parse(sessionStorage.getItem('filterValues')) || [];

                                                                    const existingIndex = filterValues.findIndex(item => field.LabelName in item);

                                                                    // If value is cleared
                                                                    if (!newValue || (Array.isArray(newValue) && newValue.length === 0)) {
                                                                        // Remove the key from session storage
                                                                        if (existingIndex !== -1) {
                                                                            filterValues.splice(existingIndex, 1);
                                                                        }
                                                                    } else {
                                                                        // Add or update the key
                                                                        const newLabelValue = Array.isArray(newValue)
                                                                            ? newValue.map(val => val[field.DisplayExpr]).join(', ')
                                                                            : newValue[field.DisplayExpr];

                                                                        const newEntry = { [field.LabelName]: newLabelValue };

                                                                        if (existingIndex !== -1) {
                                                                            filterValues[existingIndex] = newEntry;
                                                                        } else {
                                                                            filterValues.push(newEntry);
                                                                        }
                                                                    }

                                                                    sessionStorage.setItem('filterValues', JSON.stringify(filterValues));
                                                                }
                                                                }}

                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        sx={{

                                                                            '& .MuiInputBase-input': {

                                                                                fontSize: '13px',  // Set text size to 13px

                                                                            },

                                                                            '& .MuiFormLabel-root': {

                                                                                fontSize: '14px',  // Set label text size to 14px

                                                                            },

                                                                        }}

                                                                        label={field.LabelName}
                                                                        fullWidth
                                                                    />
                                                                )}
                                                            />
                                                            {Boolean(fieldState.error) && (
                                                                <FormHelperText error style={{ color: 'red', fontSize: '10px' } }>{fieldState.error?.message}</FormHelperText>
                                                            )}
                                                        </div>
                                                    );

                                                default:
                                                    return null;
                                            }
                                        }}
                                    />
                                ))}

                            </Box>
                            <Divider />
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Tooltip title='Reset' sx={{ bgcolor: '#fdd835', color: '#fff', borderRadius: '4px', height: "34px", width: "34px", padding: "5px" }}>
                                    <IconButton onClick={handleReset}>
                                        <IoMdRefresh />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip
                                    title='Apply'
                                    sx={{ bgcolor: '#43b5a2', color: '#fff', borderRadius: '4px', marginLeft: '8px', height: "34px", width: "34px", padding: "5px" }}
                                >
                                    <IconButton type='submit'>
                                        <Iconify icon='mdi:filter' />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Stack>
                        {opene && <PopUpHandle open={opene} handleClose={handleClose} error={error} errorCode={errorCode} />}
                </form>
            }
            {loading && <LoadingProgressBar />}
        </ModalPopUp>


    );

}

ApprovalHierarchyFilter.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    searchControls: PropTypes.arrayOf(
        PropTypes.shape({
            LabelName: PropTypes.string.isRequired,
            DataType: PropTypes.string.isRequired,
            DefaultValues: PropTypes.array,
            ValueExpr: PropTypes.string,
            DisplayExpr: PropTypes.string,
        })
    ).isRequired,
    getRequiredData: PropTypes.func,
    pageName: PropTypes.string.isRequired,
};